// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".orderInformation-infoContainer-l5V {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    -moz-column-gap: 30px;\n         column-gap: 30px;\n    row-gap: 30px;\n}\n\n.orderInformation-label-3O9 {\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n.orderInformation-orderContainer-YRQ {\n    margin-bottom: 80px;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoContainer": "orderInformation-infoContainer-l5V",
	"label": "orderInformation-label-3O9",
	"orderContainer": "orderInformation-orderContainer-YRQ"
};
export default ___CSS_LOADER_EXPORT___;
